import Vue from 'vue'
import Component from 'vue-class-component'
import { IStatement } from '../../model/statement'
import statementStore from '../../store/statement/statement-store'
import convoStore from '../../store/convo/convo-store'
import StatementView from '../statement/StatementView.vue'
import SaveButton from '@/components/buttons/SaveButton.vue'
import ClearButton from '@/components/buttons/ClearButton.vue'
import { focus } from 'vue-focus';
import RichText from '@/components/shared/RichText';

@Component({
  directives: { focus: focus },
  name: 'convo-edit',
  components: {
    'statement-view': StatementView,
    'save-button': SaveButton,
    'clear-button': ClearButton,
    'rich-text': RichText
  }
})
export default class ConvoEdit extends Vue {
  protected inputFocused = true;

  mounted (): void {
    console.log('ConvoEdit.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('ConvoEdit mutation: type = %j', mutation.type)
      if (mutation.type === 'feed/setType') {
        console.log('ConvoEdit mutation: payload = %j', mutation.payload)
        if(mutation.payload.type === 'convo-edit') {
          this.inputFocused = true;
/* 
          // focus on convo input 
          console.log('ConvoEdit mutation: refs = %j', this.$refs)
          const titleField = <HTMLInputElement>this.$refs.title
          console.log('ConvoEdit mutation: convo field = %j', titleField)
          titleField.focus();
 */          
        }
      }
    })
  }

  get statements () { return statementStore.state.statements }
  get convoForm () { return convoStore.state.convoForm }

  protected resetForm() : void {
    convoStore.dispatchResetConvoForm()
  }

  protected addConvo (): void {
    convoStore.dispatchAddConvo()
  }

  protected addFormTag (): void {
    convoStore.commitAddTagToForm({ })
  }

  protected removeFormTag (tag: string): void {
    convoStore.commitRemoveTagFromForm({ tag: tag })
  }

  protected addFormReference (): void {
    convoStore.commitAddReferenceToForm({ })
  }

  protected removeFormReference (index: number): void {
    convoStore.commitRemoveReferenceFromForm({ index: index })
  }

  protected removeFormStatement (statement: IStatement): void {
    convoStore.dispatchRemoveFormStatement(statement)
  }
}
